module.exports = __webpack_public_path__ + "static/michelle-00255757300b4664e001f87308e07b36.png";